function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n            .cls-1{opacity:.06}\n        "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "_404_image",
  "data-name": "404_image",
  transform: "translate(-53.91 -7.977)"
}, React.createElement("path", {
  id: "bg",
  d: "M65.5 52.5c-15.195 23.813-15.367 56.4-1 81 21.853 37.413 67.432 39.441 80 40 10.408.463 52.129 2.319 77-28 14.466-17.635 16.123-37.489 17-48 .694-8.314 5.022-57.747-27-80-22.447-15.6-49.859-8.889-78-2-27.471 6.725-52.609 12.879-68 37z",
  fill: "#a54027",
  className: "icon-contour-fill cls-1"
}), React.createElement("g", {
  id: "image"
}, React.createElement("g", {
  id: "Group_3191",
  "data-name": "Group 3191"
}, React.createElement("g", {
  id: "Group_3186",
  "data-name": "Group 3186"
}, React.createElement("path", {
  id: "Path_1887",
  d: "M113.954 83.018a1.5 1.5 0 0 1-1.482-1.285l-1.132-7.785a1.5 1.5 0 1 1 2.969-.431l1.131 7.783a1.5 1.5 0 0 1-1.268 1.7 1.463 1.463 0 0 1-.218.018zm-2.263-15.572a1.5 1.5 0 0 1-1.482-1.284l-1.132-7.785a1.5 1.5 0 0 1 2.969-.432l1.132 7.785a1.5 1.5 0 0 1-1.269 1.7 1.6 1.6 0 0 1-.218.016z",
  fill: "#a54027",
  "data-name": "Path 1887",
  className: "icon-contour-fill cls-2"
})), React.createElement("g", {
  id: "Group_3187",
  "data-name": "Group 3187"
}, React.createElement("path", {
  id: "Path_1888",
  d: "M109.428 51.876a1.5 1.5 0 0 1-1.483-1.284l-.718-4.948a1.5 1.5 0 0 1 1.268-1.7l4.948-.718a1.5 1.5 0 1 1 .432 2.968l-3.464.5.5 3.464a1.5 1.5 0 0 1-1.268 1.7 1.474 1.474 0 0 1-.215.018z",
  fill: "#a54027",
  "data-name": "Path 1888",
  className: "icon-contour-fill cls-2"
})), React.createElement("g", {
  id: "Group_3188",
  "data-name": "Group 3188"
}, React.createElement("path", {
  id: "Path_1889",
  d: "M124.5 44.634a1.5 1.5 0 0 1-.214-2.985l10.841-1.575a1.5 1.5 0 0 1 .432 2.969l-10.841 1.575a1.463 1.463 0 0 1-.218.016zm21.682-3.152a1.5 1.5 0 0 1-.214-2.984l10.841-1.575a1.5 1.5 0 1 1 .431 2.969l-10.84 1.575a1.448 1.448 0 0 1-.22.015z",
  fill: "#a54027",
  "data-name": "Path 1889",
  className: "icon-contour-fill cls-2"
})), React.createElement("g", {
  id: "Group_3189",
  "data-name": "Group 3189"
}, React.createElement("path", {
  id: "Path_1890",
  d: "M173.527 42.561a1.5 1.5 0 0 1-1.482-1.285l-.5-3.463-3.464.5a1.5 1.5 0 0 1-.432-2.968l4.949-.72a1.5 1.5 0 0 1 1.7 1.268l.719 4.949a1.5 1.5 0 0 1-1.269 1.7 1.453 1.453 0 0 1-.221.019z",
  fill: "#a54027",
  "data-name": "Path 1890",
  className: "icon-contour-fill cls-2"
})), React.createElement("g", {
  id: "Group_3190",
  "data-name": "Group 3190"
}, React.createElement("path", {
  id: "Path_1891",
  d: "M178.054 73.7a1.5 1.5 0 0 1-1.483-1.284l-1.132-7.785a1.5 1.5 0 0 1 2.969-.432l1.132 7.785a1.5 1.5 0 0 1-1.269 1.7 1.593 1.593 0 0 1-.217.016zm-2.263-15.571a1.5 1.5 0 0 1-1.482-1.284l-1.132-7.785a1.5 1.5 0 1 1 2.969-.432l1.131 7.785a1.5 1.5 0 0 1-1.268 1.7 1.464 1.464 0 0 1-.218.018z",
  fill: "#a54027",
  "data-name": "Path 1891",
  className: "icon-contour-fill cls-2"
}))), React.createElement("path", {
  id: "Path_1892",
  d: "M188.5 98H186v-8.5a1.5 1.5 0 0 0-1-1.41V84.5a1.5 1.5 0 0 0-1-1.41V79.5a1.5 1.5 0 0 0-1.5-1.5h-64a1.5 1.5 0 0 0-1.5 1.5v3.59a1.5 1.5 0 0 0-1 1.41v3.59a1.5 1.5 0 0 0-1 1.41V98h-2.5a1.5 1.5 0 0 0-1.5 1.5v47a1.5 1.5 0 0 0 1.5 1.5h76a1.5 1.5 0 0 0 1.5-1.5v-47a1.5 1.5 0 0 0-1.5-1.5zM120 81h61v2h-61zm-1 5h63v2h-63zm-1 5h65v7h-65zm69 54h-73v-44h73z",
  fill: "#a54027",
  "data-name": "Path 1892",
  className: "icon-contour-fill cls-2"
}), React.createElement("path", {
  id: "Path_1893",
  d: "M158.5 114h-16a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h16a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5zm-14.5-3h13v-3h-13z",
  fill: "#a54027",
  "data-name": "Path 1893",
  className: "icon-contour-fill cls-2"
}), React.createElement("path", {
  id: "Path_1894",
  d: "M143.669 62.9a1 1 0 0 1-.316-1.948c.6-.2 2.316-1.018 2.316-2.052a2 2 0 0 0-3.887-.668 1 1 0 1 1-1.886-.664 4 4 0 0 1 7.773 1.334c0 2.643-3.307 3.822-3.684 3.947a1 1 0 0 1-.316.051z",
  fill: "#a54027",
  "data-name": "Path 1894",
  className: "icon-contour-fill cls-2"
}), React.createElement("path", {
  id: "Path_1895",
  d: "M143.75 66.91a1.009 1.009 0 0 1-1-1.011.837.837 0 0 1 .08-.379.993.993 0 0 1 1.109-.6 1.068 1.068 0 0 1 .191.059c.059.031.12.061.17.09a1.006 1.006 0 0 1 .16.131.978.978 0 0 1 .21.32 1.031 1.031 0 0 1 .08.379.991.991 0 0 1-.29.71 1.014 1.014 0 0 1-.71.301z",
  fill: "#a54027",
  "data-name": "Path 1895",
  className: "icon-contour-fill cls-2"
})));

var Svg404Image = function Svg404Image(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 185.167,
    height: 165.715,
    viewBox: "0 0 185.167 165.715",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg404Image, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404_image.cdf1e362.svg";
export { ForwardRef as ReactComponent };